import { TEMPLATE_SENDERS_URL } from 'api/TemplatePickerAPI';
import { RestQueryHookOptions, useRestQuery } from 'utils/hooks/api/useRestQuery';

type QuerySendProgressResponse = {
  authedEmails: any[];
  smsEsps: any[];
  smsMessageTypes: any[];
  smsSenders: any[];
  validSendDomains: any[];
};

export const useTemplateSenders = (options?: RestQueryHookOptions<QuerySendProgressResponse>) => {
  const { isLoading, data, error, refetch } = useRestQuery(TEMPLATE_SENDERS_URL, undefined, {
    ...options,
  });

  return { isLoading, data, error, refetch };
};
